document.addEventListener("DOMContentLoaded", function () {
  let selectedSize = "";

  const container = document.querySelector(".fabric-estimator-container");
  if (!container) return;

  let selectedValues = {
    garment: "",
    type: "",
    style: "",
    size: "",
    width: "",
  };

  container.addEventListener("click", async function (e) {
    const steps = document.querySelectorAll(
      ".fabric-estimator-container .step-container .step"
    );

    const nextBtn = e.target.closest(".tangent_survey_next_button_custom");
    if (nextBtn) {
      const activeSteps = [...steps].filter(step =>
        step.classList.contains("active")
      );
      const currentStep = activeSteps[activeSteps.length - 1];
      const currentIndex = [...steps].indexOf(currentStep);

      if (currentIndex === 3 && !selectedValues.width) {
        const checkedWidth = document.querySelector(
          'input[name="fabric_length"]:checked'
        );
        if (checkedWidth) {
          selectedValues.width = checkedWidth.value;
        }
      }

      if (
        (currentIndex === 3 || currentIndex === 4) &&
        currentIndex + 1 < steps.length
      ) {
        steps[currentIndex + 1].classList.add("active");
        return;
      }

      if (
        currentStep.classList.contains("fill") &&
        currentIndex + 1 < steps.length
      ) {
        steps[currentIndex + 1].classList.add("active");
      }

      return;
    }

    const option = e.target.closest(".tangent_options_custom");
    if (option) {
      const selectedTextEl = option.querySelector(".tngnt-option-text");
      const selectedText = selectedTextEl?.textContent.trim() || "";
      if (!selectedText) return;

      const activeSteps = [...steps].filter(step =>
        step.classList.contains("active")
      );
      const activeStep = activeSteps[activeSteps.length - 1];
      const currentIndex = [...steps].indexOf(activeStep);
      if (!activeStep) return;

      if (currentIndex === 2) {
        const checkedSize = document.querySelector(
          'input[name="size"]:checked'
        );
        if (checkedSize) {
          selectedValues.size = checkedSize.value;
        }
      }

      if (currentIndex <= 3) {
        activeStep.querySelector(".selected-value")?.remove();

        const valueDiv = document.createElement("div");
        valueDiv.className = "selected-value";
        valueDiv.textContent = selectedText;
        activeStep.appendChild(valueDiv);
        activeStep.classList.add("fill");

        if (currentIndex === 0) selectedValues.garment = selectedText;
        if (currentIndex === 1) selectedValues.type = selectedText;
        if (currentIndex === 2) {
          selectedValues.style = selectedText;
          updateSizeVisibility();
        }

        if (currentIndex + 1 < steps.length) {
          steps[currentIndex + 1].classList.add("active");
        }
      }
      return;
    }

    const backBtn = e.target.closest(".tangent_backbtn_custom");
    if (backBtn) {
      const activeSteps = [...steps].filter(step =>
        step.classList.contains("active")
      );
      if (activeSteps.length > 1) {
        const currentStep = activeSteps[activeSteps.length - 1];
        currentStep.querySelector(".selected-value")?.remove();
        currentStep.classList.remove("fill", "active");
        document.querySelector(".block_fabric-error")?.classList.add("hidden");
      }
      return;
    }

    if (e.target.name === "size") {
      selectedSize = e.target.value;
      selectedValues.size = selectedSize;

      const radios = [...document.querySelectorAll('input[name="size"]')];
      const index = radios.indexOf(e.target);

      document
        .querySelectorAll(".size-table .size-cell")
        .forEach(el => el.classList.remove("selected"));

      document.querySelectorAll(".size-table .size-row").forEach(row => {
        const cells = row.querySelectorAll(".size-cell");
        if (cells[index + 1]) cells[index + 1].classList.add("selected");
      });
    }

    if (e.target.name === "fabric_length") {
      selectedValues.width = e.target.value;
    }
  });
});

function normalize(value) {
  return (value || "").toString().trim().toLowerCase();
}

function updateSizeVisibility() {
  const selectedNodes = document.querySelectorAll(".step-container .selected-value");
document.getElementsByClassName("tangent_686245d7c72c6b615ceceb7a_survey_next_button_custom")[0].classList.add("hidden")

  const selectedData = {
    garment: selectedNodes[0]?.textContent.trim() || "",
    type: selectedNodes[1]?.textContent.trim() || "",
    style: selectedNodes[2]?.textContent.split("/")[0].trim() || ""
  };

  fetch("https://script.google.com/macros/s/AKfycbwpyxt1SYAot4U2DzcqyIbz8ifUdQR6CBiI0bbBGOpqHhnWLNrJZgcqL_YIaPsX9o1k/exec")
    .then(res => res.json())
    .then(resData => {
      const matchedRows = resData.data.filter(row =>
        normalize(row.Garment) === normalize(selectedData.garment) &&
        normalize(row.Type) === normalize(selectedData.type) &&
        normalize(row.Style) === normalize(selectedData.style)
      );

      document.querySelectorAll(".block_size-cell").forEach(el => {
        el.classList.add("block_size-cell-hidden");
      });

      matchedRows.forEach(row => {
        const sizeValue = Number(row.Size);
        document.querySelectorAll(`.block_cell-${sizeValue}`).forEach(el => {
          el.classList.remove("block_size-cell-hidden");
          el.dataset.width = row["Width (in)"] || "";
        });
      });
      document.querySelector(".block_size-cell-loader").classList.add("hidden");
            document.querySelector(".size-table").classList.remove("block_size-cell-table-hidden");
            document.getElementsByClassName("tangent_686245d7c72c6b615ceceb7a_survey_next_button_custom")[0].classList.remove("hidden")
      
    })
    .catch(console.error);
}

document.addEventListener("click", () => {
  const btn = document.getElementsByClassName(
    "tangent_686245d7c72c6b615ceceb7a_survey_next_button_custom"
  )[0];

  if (!btn || btn.dataset.bound) return;
  btn.dataset.bound = "true";

  btn.addEventListener("click", event => {
    event.stopPropagation();
    btn.classList.add("loading-btn");

    const selectedEls = document.querySelectorAll(".step-container .selected-value");
    const selected = {
      Garment: selectedEls[0]?.textContent.trim() || "",
      Type: selectedEls[1]?.textContent.trim() || "",
      Style: selectedEls[2]?.textContent.split("/")[0].trim() || "",
      Size: document.querySelector('.size-cell.selected input[name="size"]:checked')?.value || ""
    };

    fetch("https://script.google.com/macros/s/AKfycbwpyxt1SYAot4U2DzcqyIbz8ifUdQR6CBiI0bbBGOpqHhnWLNrJZgcqL_YIaPsX9o1k/exec")
      .then(res => res.json())
      .then(data => {
        const matches = data.data.filter(item =>
          normalize(item.Garment) === normalize(selected.Garment) &&
          normalize(item.Type) === normalize(selected.Type) &&
          normalize(item.Style) === normalize(selected.Style) &&
          normalize(item.Size) === normalize(selected.Size)
        );

        btn.classList.remove("loading-btn");

        if (!matches.length) {
          document.querySelector(".block_fabric-error")?.classList.remove("hidden");
          return;
        }

        localStorage.setItem("fabricEstimatorMatchesAll", JSON.stringify(matches));

        document.getElementById("tangent-main-container")?.classList.add("hidden");
        document.querySelector(".fabric-result")?.classList.remove("hidden");

        const infoBox = document.querySelector(".block_fabric-size-info");
        if (!infoBox) return;

        infoBox.innerHTML = matches
          .map((m, i) => `<div class="width-option block_width-info" data-index="${i}">${m["Width (in)"]}</div>`)
          .join("");

        infoBox.querySelectorAll(".width-option").forEach(el => {
          el.addEventListener("click", () => {
            infoBox.querySelectorAll(".width-option").forEach(p => p.classList.remove("selected"));
            el.classList.add("selected");
            localStorage.setItem(
              "fabricEstimatorSelectedWidth",
              JSON.stringify(matches[el.dataset.index])
            );
          });
        });

        infoBox.querySelector(".width-option")?.click();
      })
      .catch(console.error);
  });
});

document.querySelector(".block_button-info-back")?.addEventListener("click", function () {
  localStorage.removeItem("fabricEstimatorMatchesAll");
  localStorage.removeItem("fabricEstimatorSelectedWidth");
  document.getElementById("tangent-main-container")?.classList.remove("hidden");
  document.querySelector(".fabric-result")?.classList.add("hidden");
});
